module.exports = __webpack_public_path__ + "img/bg_menubook.5bc3b4b5.jpg";